import React from 'react';
import { Heart } from 'lucide-react';

const Footer = ({ tagline, subline }) => {
  return (
    <footer className="bg-footer-blue">
      <div className="max-w-7xl mx-auto px-6 py-8 text-center">
        <div className="flex items-center justify-center gap-3">
          <Heart className="w-6 h-6" style={{ color: 'var(--gold)' }} />
          <p className="font-script text-2xl md:text-3xl" style={{ color: 'var(--gold)' }}>{tagline}</p>
          <Heart className="w-6 h-6" style={{ color: 'var(--coral)' }} fill="var(--coral)" />
        </div>
        {subline && (
          <p className="font-head text-white/90 tracking-wide text-xs md:text-sm mt-2 uppercase">{subline}</p>
        )}
      </div>
    </footer>
  );
};

export default Footer;
